import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    tabLabel: {
      fontSize: "0.9rem"
    },
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4"
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    }
  })
);
